<template>
	<!--
      作者：luoyiming
      时间：2019-10-25
      描述：订单列表
  -->
	<div class="user">
		<div class="cards-wrap" style="background-color: #FFFFFF; margin: 20px auto;">
			<el-row :gutter="20">
				<el-col :span="6" class="d-c-c">
					<div class="grid-content blue">
						<div class="info">
							<h3>待接单</h3>
							<p>{{ data_count.pending_order || 0 }}</p>
							<p>技师未接单订单</p>
						</div>
					</div>
				</el-col>
				<el-col :span="6" class="d-c-c"
					style="font-size: 18px;display: flex;justify-content: center;align-items: center;">
					<div class="grid-content yellow">
						<div class="info">
							<h3>即将到钟订单</h3>
							<p>{{ data_count.clock || 0 }}</p>
							<p>订单即将到钟</p>
						</div>
					</div>
				</el-col>
				<el-col :span="6" class="d-c-c">
					<div class="grid-content  purple">
						<div class="info">
							<h3>已完成订单</h3>
							<p>{{ data_count.completed || 0 }}</p>
							<p>服务已完成订单</p>
						</div>
					</div>
				</el-col>
				<el-col :span="6" class="d-c-c">
					<div class="grid-content orderred">
						<div class="info ">
							<h3>已结算订单</h3>
							<p>{{ data_count.is_settled || 0 }}</p>
							<p>已参与分佣订单</p>
						</div>
					</div>
				</el-col>
			</el-row>
		</div>

		<!--搜索表单-->
		<div class="common-seach-wrap">
			<el-form size="small" :inline="true" :model="searchForm" label-width="60px" class="demo-form-inline">

				<el-form-item label="订单号">
					<el-input size="small" v-model="searchForm.orderNo" placeholder="请输入订单号"></el-input>
				</el-form-item>
				<el-form-item label="支付方式">
					<el-select size="small" v-model="searchForm.payType" placeholder="请选择">
						<el-option label="全部" value=""></el-option>
						<el-option v-for="(item, index) in payType" :key="index" :label="item.name"
							:value="item.value"></el-option>
					</el-select>
				</el-form-item>

				<el-form-item label="商家">
					<el-select size="small" v-model="searchForm.shopSupplierId" placeholder="请选择">
						<el-option label="全部" value=""></el-option>
						<el-option v-for="(item, index) in supplierList" :key="index" :label="item.name"
							:value="item.shopSupplierId"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="用户">
					<el-input size="small" v-model="searchForm.search" placeholder="请输入用户ID|昵称|手机号"></el-input>
				</el-form-item>
				<el-form-item label="起始时间">
					<div class="block">
						<span class="demonstration"></span>
						<el-date-picker size="small" v-model="searchForm.createTime" type="daterange"
							value-format="yyyy-MM-dd" range-separator="至" start-placeholder="开始日期"
							end-placeholder="结束日期"></el-date-picker>
					</div>
				</el-form-item>
				<el-form-item>
					<el-button size="small" type="primary" icon="el-icon-search" @click="onSubmit">查询</el-button>
				</el-form-item>
				<el-form-item>
					<el-button size="small" type="success" @click="onExport">导出</el-button>
				</el-form-item>
			</el-form>
		</div>
		<div style="margin: 20px 0;display: flex; flex-direction: column;">
			<div style="display: flex;align-items: center;margin: 10px 0;">
				<div>支付状态：</div>
				<el-radio-group v-model="searchForm.payStatus" size="mini" @change="onSubmit">
					<el-radio-button label="">全部</el-radio-button>
					<el-radio-button label="10">未支付</el-radio-button>
					<el-radio-button label="20">已支付</el-radio-button>
				</el-radio-group>
			</div>
			<div style="display: flex;align-items: center;margin: 10px 0;">
				<div>订单状态：</div>
				<el-radio-group v-model="searchForm.orderTypes" size="mini" @change="onSubmit">
					<el-radio-button label="">全部</el-radio-button>
					<el-radio-button label="is_transfer">变更订单</el-radio-button>
					<el-radio-button label="isClock">加钟订单</el-radio-button>
					<el-radio-button label="cancel_no_pay">取消未支付</el-radio-button>
					<el-radio-button label="cancel_pay" value="">取消已支付</el-radio-button>
				</el-radio-group>
			</div>
		</div>
		<!--内容-->
		<el-tabs v-model="activeName" @tab-click="handleClick">
			<el-tab-pane label="全部" name="all"></el-tab-pane>
			<el-tab-pane :label="'待付款'" name="payment">
				<span slot="label">待付款 ({{ order_count.payment }})</span>
			</el-tab-pane>
			<el-tab-pane :label="'待接单'" name="pending_order">
				<span slot="label">待接单 ({{ order_count.pending_order }})</span>
			</el-tab-pane>
			<el-tab-pane :label="'待出发'" name="received_order">
				<span slot="label">待出发 ({{ order_count.received_order }})</span>
			</el-tab-pane>
			<el-tab-pane :label="'待收货'" name="have_set_out">
				<span slot="label">待到达 ({{ order_count.have_set_out }})</span>
			</el-tab-pane>
			<el-tab-pane label="待服务" name="have_arrived">
				<span slot="label">待服务 ({{ order_count.have_arrived }})</span>
			</el-tab-pane>
			<el-tab-pane label="服务中" name="in_service">
				<span slot="label">服务中 ({{ order_count.in_service }})</span>
			</el-tab-pane>
			<el-tab-pane label="已完成" name="completed">
				<span slot="label">已完成 ({{ order_count.completed }})</span>
			</el-tab-pane>
			<el-tab-pane label="待评价" name="evaluate">
				<span slot="label">已评价 ({{ order_count.evaluate }})</span>
			</el-tab-pane>
			<el-tab-pane label="申请取消" name="cancel">
				<span slot="label">已取消 ({{ order_count.cancel }})</span>
			</el-tab-pane>
			<el-tab-pane label="已取消" name="is_cancel">
				<span slot="label">已退款 ({{ order_count.is_cancel }})</span>
			</el-tab-pane>
		</el-tabs>
		<div class="table-wrap">
			<el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading">
				<el-table-column prop="orderNo" align="center" label="订单编号" width="220">
					<template slot-scope="scope">
						<div class="" style="display: flex; flex-direction: column;">
							<div class="order-code" style="display: flex;align-items: center;">
								<span class="state-text" :class="{ 'state-text-red': scope.row.orderSource != 10 }">
									{{ scope.row.orderSourceText }}
								</span>
								<span class="c_main pl16">{{ scope.row.orderNo }}</span>
							</div>
						</div>
					</template>
				</el-table-column>
				<el-table-column prop="user" align="center" label="下单用户" width="150">
					<template slot-scope="scope" v-if="!scope.row.is_top_row && scope.row.user">
						<div class=""
							style="display: flex; flex-direction: column;align-items: center;justify-content: center;">
							<H4>{{ scope.row.user.nickName }}</H4>
							<span class="gray9"> ID：{{ scope.row.user.userId }}</span>
							<span v-if="scope.row.address && scope.row.address.phone">{{ scope.row.address
								? scope.row.address.phone : '--' }}</span>
						</div>
					</template>
				</el-table-column>
				<el-table-column prop="orderNo" label="服务项目" width="350">
					<template slot-scope="scope">
						<div class="product-info" v-for="(item, index) in scope.row.productList" :key="index">
							<div class="pic" v-if="item.imagePath"><img v-img-url="item.imagePath" alt="" />
							</div>
							<div class="info">
								<div class=" gray3 product-name">
									<span>{{ item.productName }}</span>
									<div class="gray9">{{ item.serviceTime }} 分钟</div>
									<div class="orange">预约：{{ scope.row.anticipate_time_text }}</div>

								</div>
								<div class="gray9" v-if="item.productAttr">{{ item.productAttr }}</div>
								<div class="orange" v-if="item.refund">
									{{ item.refund.type.text }}-{{ item.refund.status.text }}
								</div>
							</div>
							<div class="d-c-c d-c">
								<div class="orange">￥ {{ item.productPrice }}</div>
								<div class="gray3">x{{ item.totalNum }}</div>
							</div>
						</div>
					</template>
				</el-table-column>
				<el-table-column prop="payPrice" align="center" label="实付金额" width="120">
					<template slot-scope="scope" v-if="!scope.row.is_top_row">
						<span style="color:red"> ￥{{ scope.row.payPrice }}</span>
					</template>
				</el-table-column>
				<el-table-column prop="supplier.name" align="center" label="商户信息" width="120">
					<template slot-scope="scope" v-if="!scope.row.is_top_row && scope.row.supplier">
						<div style="display: flex;flex-direction: column;">
							<span>{{ scope.row.supplier ? scope.row.supplier.name : '' }}</span>
							<span class="gray9">ID：{{ scope.row.supplier.shopSupplierId }}</span>
						</div>
					</template>
				</el-table-column>
				<el-table-column prop="" align="center" label="服务技师" width="120">
					<template slot-scope="scope" v-if="!scope.row.is_top_row && scope.row.waiter">
						<div style="display:flex; flex-direction: column;align-items: center;justify-content: center;">
							<!-- <img class="img" v-img-url="scope.row.waiter.avatarUrl" alt="" /> -->
							<H4>{{ scope.row.waiter ? scope.row.waiter.username : '' }}</H4>
							<span class="gray9">ID:{{ scope.row.waiter ? scope.row.waiter.waiterUserId : '' }}</span>
							<span v-if="scope.row.waiterAddress">
								{{ scope.row.waiterAddress ? scope.row.waiterAddress.mobile : '' }}
							</span>
						</div>
					</template>
				</el-table-column>
				<el-table-column prop="orderType" align="center" label="预约形式" width="120">
					<template slot-scope="scope">
						<el-tag v-if='scope.row.orderType == 0' type="warning">预约上门</el-tag>
						<el-tag v-else-if='scope.row.orderType == 1'>预约到店</el-tag>
					</template>
				</el-table-column>
				<el-table-column prop="fareParam" align="center" label="出行方式" width="120">
					<template slot-scope="scope">
						<div style="display: flex;flex-direction: column;text-align: center;">
							<span v-if="scope.row.fareParam" style="color:rgb(99, 180, 59)">{{
								changetext(scope.row.fareParam, 1) }}</span>
							<span v-if="scope.row.fareParam"
								style="color:rgb(255, 0, 0)">￥{{ changetext(scope.row.fareParam, 2) }}</span>
						</div>
					</template>
				</el-table-column>
				<el-table-column prop="createTime" align="center" label="下单时间" width="160"></el-table-column>
				<el-table-column prop="payTypeText" align="center" label="支付方式" width="160">
					<!-- <template slot-scope="scope" v-if="!scope.row.is_top_row">
						<span class="">
							<el-tag v-if='scope.row.payType == 10' type="warning">余额支付</el-tag>
							<el-tag v-else-if='scope.row.payType == 30'>支付宝支付</el-tag>
							<el-tag v-else-if='scope.row.payType == 20' type="success">微信支付</el-tag>
						</span>
						<span v-if='scope.row.payStatus == 20' style="color:green">{{ scope.row.payStatusText }}</span>
						<span v-else style="color:red">{{ scope.row.payStatusText }}</span>
					</template> -->
				</el-table-column>
				<el-table-column prop="orderStatusText" align="center" label="交易状态" fixed="right"
					width="120"></el-table-column>
				<el-table-column fixed="right" label="操作" width="240">
					<template slot-scope="scope" v-if="!scope.row.is_top_row">
						<el-button @click="addClick(scope.row)" type="info" size="small"
							v-auth="'/order/order/detail'">详情</el-button>
						<el-button @click="statusClick(scope.row)" type="primary" size="small"
							v-auth="'/order/order/detail'">更改状态</el-button>
						<el-button v-if="scope.row.waiter_state <= 4 && scope.row.payStatus.value == 20"
							@click="transferClick(scope.row)" type="success" size="small"
							v-auth="'/user/user/recharge'">转单</el-button>
					</template>

				</el-table-column>
			</el-table>
		</div>
		<!--分页-->
		<div class="pagination">
			<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" background
				:current-page="curPage" :page-size="pageSize" layout="total, prev, pager, next, jumper"
				:total="totalDataNumber"></el-pagination>
		</div>
		<Logistics :logisticsData="logisticsData" :isLogistics="isLogistics" @closeDialog='closeLogistics'></Logistics>
		<Recharge v-if="open_add" :open_add="open_add" :form="userModel" @closeDialog="closeDialogFunc($event, 'add')">
		</Recharge>
		<!--编辑-->
		<orderStatus v-if="open_orderStatus" :open_orderStatus="open_orderStatus" :form="userModel"
			@closeDialog="closeDialogFunc($event, 'orderStatus')"></orderStatus>
		<orderTransfer v-if="open_orderTransfer" :open_orderTransfer="open_orderTransfer" :form="userModel"
			@closeDialog="closeDialogFunc($event, 'orderTransfer')"></orderTransfer>
	</div>
</template>

<script>
import OrderApi from "@/api/order.js";
import Logistics from "@/components/logistics/viewLogistics.vue";
import Recharge from "./dialog/Recharge.vue";
import orderStatus from "./dialog/order-status.vue";
import orderTransfer from "./dialog/order-transfer.vue";
import qs from "qs";
export default {
	components: {
		Logistics,
		Recharge,
		orderStatus,
		orderTransfer
	},
	data() {
		return {
			/*所有标签*/
			allTag: [],
			/*切换菜单*/
			activeName: "all",
			/*是否加载完成*/
			loading: true,
			/*列表数据*/
			tableData: [],
			/*一页多少条*/
			pageSize: 20,
			/*一共多少条数据*/
			totalDataNumber: 0,
			/*当前是第几页*/
			curPage: 1,
			/*横向表单数据模型*/
			searchForm: {
				orderNo: "",
				search: "",
				style_id: "",
				createTime: "",
				payType: "",
				shopSupplierId: "",
				orderType: '',
				orderTypes: '',
				payStatus: '',
			},
			/*配送方式*/
			exStyle: [],
			hotel: [],
			/*门店列表*/
			shopList: [],
			supplierList: [],
			payType: [],
			/*时间*/
			createTime: "",
			/*统计*/
			data_count: {},
			order_count: {
				cancel: 0,
				completed: 0,
				evaluate: 0,
				have_arrived: 0,
				have_set_out: 0,
				in_service: 0,
				is_cancel: 0,
				payment: 0,
				pending_order: 0,
				received_order: 0
			},
			isLogistics: false,
			logisticsData: {},
			/*是否打开添加弹窗*/
			open_add: false,
			open_orderStatus: false,
			open_orderTransfer: false,
			/*当前编辑的对象*/
			userModel: {}
		};
	},
	created() {
		/*获取列表*/
		this.getData();
	},
	methods: {
		/*跨多列*/
		arraySpanMethod(row) {
			if (row.rowIndex % 2 == 0) {
				if (row.columnIndex === 0) {
					return [1, 10];
				}
			}
		},
		/*选择第几页*/
		handleCurrentChange(val) {
			let self = this;
			self.curPage = val;
			self.getData();
		},

		/*每页多少条*/
		handleSizeChange(val) {
			this.curPage = 1;
			this.pageSize = val;
			this.getData();
		},

		/*切换菜单*/
		handleClick(tab, event) {
			let self = this;
			self.curPage = 1;
			self.getData();
		},
		statusClick(item) {
			this.userModel = item;
			this.open_orderStatus = true;
		},
		/*关闭弹窗*/
		closeDialogFunc(e, f) {
			if (f == "orderStatus") {
				this.open_orderStatus = e.openDialog;
				if (e.type == "success") {
					this.getData();
				}
			}
			if (f == "orderTransfer") {
				this.open_orderTransfer = e.openDialog;
				if (e.type == "success") {
					this.getData();
				}
			}
			if (f == "add") {
				this.open_add = e.openDialog;
				if (e.type == "success") {
					this.getData();
				}
			}
		},
		/*获取列表*/
		getData() {
			let self = this;
			let Params = this.searchForm;
			Params.dataType = self.activeName;
			console.log("=============", self.activeName);
			Params.pageIndex = self.curPage;
			Params.pageSize = self.pageSize;
			self.loading = true;
			OrderApi.orderlist(Params, true)
				.then(res => {
					console.log(res.data, '订单列表')
					let list = [];
					for (let i = 0; i < res.data.list.data.length; i++) {
						let item = res.data.list.data[i];
						// let topitem = {
						// 	orderNo: item.orderNo,
						// 	createTime: item.createTime,
						// 	order_source: item.order_source,
						// 	order_source_text: item.order_source_text,
						// 	order_status: item.order_status.value
						// };
						// list.push(topitem);
						list.push(item);
					}
					self.tableData = list;
					self.payType = res.data.payType;
					self.supplierList = res.data.supplierList;
					self.totalDataNumber = res.data.list.total;
					self.exStyle = res.data.ex_style;
					self.hotel = res.data.hotel;
					self.order_count = res.data.orderCount;
					self.data_count = res.data.dataCount;
					self.loading = false;
				})
				.catch(error => { });
		},
		changetext(val, e) {
			if (val) {
				let a = JSON.parse(val)
				if (e == 1) {
					return a.msg
				} else {
					return a.price

				}

			}
		},
		/*打开添加*/
		addClick(row) {
			let self = this;
			let params = row.orderId;
			self.$router.push({
				path: "/order/order/Detail",
				query: {
					orderId: params
				}
			});
		},
		// 转单
		transferClick(row) {
			this.userModel = row;
			this.open_orderTransfer = true;
			// transferOrder
			const shopSupplierId = row.supplier.shopSupplierId

		},

		cancelClick(row) {
			let self = this;
			let Params = {
				orderId: row.orderId,
				is_cancel: 1
			};
			self
				.$confirm("确定取消该订单?", "提示", {
					type: "warning"
				})
				.then(() => {
					OrderApi.confirm(Params, true).then(res => {
						self.$message({
							message: res.msg,
							type: "success"
						});
						self.getData();
					});
				});
		},
		getLogistics(row) {
			let self = this;
			let Params = {
				orderId: row.orderId
			};
			self.loading = true;
			OrderApi.queryLogistics(Params, true)
				.then(res => {
					self.logisticsData = res.data.express.list;
					self.loading = false;
					console.log(self.logisticsData);
					self.openLogistics();
				})
				.catch(error => {
					self.loading = false;
				});
		},
		openLogistics() {
			this.isLogistics = true;
		},
		closeLogistics() {
			this.isLogistics = false;
		},
		/*搜索查询*/
		onSubmit() {
			this.curPage = 1;
			this.tableData = [];
			this.getData();
		},
		onExport: function () {
			let baseUrl = window.location.protocol + "//" + window.location.host;
			window.location.href =
				baseUrl +
				"/index.php/shop/order.operate/export?" +
				qs.stringify(this.searchForm);
		}
	}
};
</script>
<style lang="scss">
.el-date-editor .el-range-input {
	background: white !important;
}

.cards-wrap {
	padding: 0 20px;
	color: #ffffff;
}

.cards-wrap .grid-content {
	width: 100%;
	justify-content: flex-start;
	align-items: center;
	padding-left: 23px;
}

.cards-wrap .grid-content .info {
	margin: 20px;
	text-align: left;
	font-size: 18px;
	color: #ffffff;
}

.cards-wrap .grid-content .info h3 {
	font-size: 26px;
	line-height: 26px;
	color: #ffffff;
	text-align: left;
	margin-bottom: 20px;
}

.cards-wrap .grid-content.blue {
	background: url(/static/imgs/total_shop.png) no-repeat;
	background-size: 100% 100%;
}

.cards-wrap .grid-content.yellow {
	background: url(/static/imgs/total_user.png) no-repeat;
	background-size: 100% 100%;
}

.cards-wrap .grid-content.purple {
	background: url(/static/imgs/total_volume.png) no-repeat;
	background-size: 100% 100%;
}

.cards-wrap .grid-content.orderred {
	background: url(/static/imgs/total_order.png) no-repeat;
	background-size: 100% 100%;
}




.product-info {
	display: flex;
	padding: 10px 0;
	border-top: 1px solid #eeeeee;
}

.order-code .state-text {
	padding: 0px 4px;
	// border-radius: 4px;
	background: #808080;
	color: #ffffff;
}

.order-code .state-text-red {
	background: red;
}

.table-wrap .product-info:first-of-type {
	border-top: none;
}

.table-wrap .el-table__body tbody .el-table__row:nth-child(odd) {
	background: #f5f7fa;
}
</style>
<style lang="scss" scoped>
.img {
	width: 60px;
	height: 60px;
}

.body-h {
	height: calc(100vh - 300px);
}
</style>


// WEBPACK FOOTER //
// src/views/order/order/index.vue